import { createApiClient } from '@pomodingo/api-client';
import { createWebPlatform } from '../platform/web';

function resolveApiBaseUrl(): string {
  if (import.meta.env.VITE_API_URL) {
    return import.meta.env.VITE_API_URL;
  }
  if (import.meta.env.VITE_SERVER_URL) {
    return import.meta.env.VITE_SERVER_URL;
  }
  return '';
}

export const platform = createWebPlatform({ apiBaseUrl: resolveApiBaseUrl() });

export const api = createApiClient(
  {
    baseUrl: platform.config.apiBaseUrl,
    getToken: () => platform.tokenStore.getAccessToken(),
  },
  platform.tokenStore,
);

export function getApiBaseUrl(): string {
  return platform.config.apiBaseUrl;
}
